import Control from 'ol/control/Control'
import { transformExtent } from 'ol/proj'

import { map } from '../map/tools'

// Zoom home button.
export class ZoomHomeControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    if (options.id) { button.id = options.id; }
    button.title = 'Zoom til eget område';
    button.innerHTML = '<i class="material-icons">home</i>';
      // <i class="material-icons">aspect_ratio</i>\
      // <i class="material-icons">public</i>\
      // <i class="material-icons">home</i>\
      // <i class="material-icons">wallpaper</i>\

    const element = document.createElement('div');
    element.className = 'zoom-home ol-unselectable ol-control';
    element.appendChild(button);

    super({ element: element, target: options.target });

    button.addEventListener('click', this.zoomToOwnRegion.bind(this));
  }

  zoomToOwnRegion = (e) => {
    // console.log('click, zoom til eget område');
    // console.log(e.target.parentNode);
    const zh = document.getElementById('zoomHome');
    const initialExtentBecameString = zh.getAttribute('data-initialExtent');
    if (initialExtentBecameString) {
      const stringArray = initialExtentBecameString.split(',');
      const initialExtent = stringArray.map(s => Number(s));
      const v = map.getView();
      const currentEpsg = v.getProjection().getCode();
      v.fit(
        transformExtent(initialExtent, 'EPSG:4258', currentEpsg),
        { duration: 2000 }
      );
    } else {
      console.log('initialExtent has not been previously stored');
    }
  };
}

